/* eslint-disable react/jsx-one-expression-per-line */
import { useHookstate } from '@hookstate/core'
import { Autocomplete, FormControl, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useLang } from '~/hooks/useLang'
import { WorkShiftTypeResponse } from './interfaces'
import { Validation as validation } from '@hookstate/validation'
import { getWorkShiftById, getWorkShifts } from '~/features/Resources/Schedule/WorkShiftRegistration/services'

interface SelectWorkShiftTypeProps {
  readonly onWorkShiftTypeChange: (value: WorkShiftTypeResponse | null) => void
  readonly workShiftTypeId?: number | null
  readonly disabled?: boolean
  readonly readonly?: boolean
  readonly isInvalidRequest?: any
  readonly isRequired?: boolean // nova prop
}

export default function FilterAutocompleteWorkShiftType({
  onWorkShiftTypeChange,
  readonly = false,
  workShiftTypeId,
  disabled,
  isInvalidRequest,
  isRequired = false, // valor padrão
}: SelectWorkShiftTypeProps) {
  const { translate } = useLang()
  const [options, setOptions] = React.useState<readonly WorkShiftTypeResponse[]>([])
  const [value, setValue] = useState<WorkShiftTypeResponse | null>(null)
  const loading = useHookstate(false)
  const isFirstRender = React.useRef(true)

  useEffect(() => {
    if (value) {
      if (workShiftTypeId != (value ? value['id'] : null)) {
        isFirstRender.current = true
        setValue(null)
      }
    }
  }, [])

   useEffect(() => {
     if (!workShiftTypeId) {
              setValue(null)
          }
  
   }, [workShiftTypeId])

  useEffect(() => {
    loading.set(true)
    getWorkShifts().then((workShiftTypes) => {
      setOptions(workShiftTypes.data || [])
      loading.set(false)
    }).catch(() => {
      setOptions([])
      loading.set(false)
    })
  }, [])

  useEffect(() => {
    if (workShiftTypeId) {
      getWorkShiftById(workShiftTypeId).then((response) => {
        const data: WorkShiftTypeResponse = response;
        setValue(data)
        onWorkShiftTypeChange(data)
      })
      isFirstRender.current = false
    }
  }, [workShiftTypeId])


  if (!readonly) {
    return (
      <FormControl fullWidth size="small">
        <Autocomplete
          id="filter-workShiftType"
          options={options}
          disabled={disabled}
          value={value}
          noOptionsText={translate('No options')}
          size="small"
          loading={loading.get()}
          isOptionEqualToValue={(option, value) => option === value}
          getOptionLabel={(option) => option.name ?? ''}
          onChange={(_, workShiftType) => {
            setValue(workShiftType)
            onWorkShiftTypeChange(workShiftType ?? null)
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={`${translate('Work shift')}${isRequired ? ' *' : ''}`}
              error={isInvalidRequest && Boolean(!workShiftTypeId)}
            />
          )}
        />
      </FormControl>
    )
  } else {
    return (
      <Typography>
        {translate('WorkShiftType')}
        {isRequired ? ' *' : ''}: {value?.name ?? translate('No information')}
      </Typography>
    )
  }
}
